var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___MWU1OD",
  "jf": "VoiceConnectionStatus.module__statusRow___MWU1OD",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___MWU1OD",
  "kR": "VoiceConnectionStatus.module__signalIcon___MWU1OD",
  "rI": "VoiceConnectionStatus.module__statusButton___MWU1OD",
  "QQ": "VoiceConnectionStatus.module__statusConnected___MWU1OD",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___MWU1OD",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___MWU1OD",
  "ne": "VoiceConnectionStatus.module__controls___MWU1OD",
  "uH": "VoiceConnectionStatus.module__controlButton___MWU1OD",
  "wH": "VoiceConnectionStatus.module__selected___MWU1OD",
  "Kk": "VoiceConnectionStatus.module__icon___MWU1OD",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___MWU1OD",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___MWU1OD",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___MWU1OD",
  "_R": "VoiceConnectionStatus.module__channelSourceText___MWU1OD",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___MWU1OD",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___MWU1OD",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___MWU1OD",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___MWU1OD",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___MWU1OD",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___MWU1OD",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___MWU1OD",
  "EU": "VoiceConnectionStatus.module__mediaSection___MWU1OD",
  "LA": "VoiceConnectionStatus.module__mediaButton___MWU1OD",
  "A1": "VoiceConnectionStatus.module__cameraActive___MWU1OD",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___MWU1OD",
  "cU": "VoiceConnectionStatus.module__mediaIcon___MWU1OD",
  "jC": "VoiceConnectionStatus.module__popoutContainer___MWU1OD",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___MWU1OD",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___MWU1OD",
  "hY": "VoiceConnectionStatus.module__popoutHeader___MWU1OD",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___MWU1OD",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___MWU1OD",
  "nO": "VoiceConnectionStatus.module__popoutStats___MWU1OD",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___MWU1OD",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___MWU1OD",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___MWU1OD",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___MWU1OD",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___MWU1OD",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___MWU1OD",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___MWU1OD",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___MWU1OD",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___MWU1OD",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___MWU1OD",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___MWU1OD",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___MWU1OD",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___MWU1OD",
  "mp": "VoiceConnectionStatus.module__deviceBadge___MWU1OD",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___MWU1OD",
  "hn": "VoiceConnectionStatus.module__endpointBadge___MWU1OD",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___MWU1OD",
  "_v": "VoiceConnectionStatus.module__chartContainer___MWU1OD",
  "nS": "VoiceConnectionStatus.module__chartSvg___MWU1OD",
  "$s": "VoiceConnectionStatus.module__gridLine___MWU1OD",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___MWU1OD",
  "eB": "VoiceConnectionStatus.module__gridText___MWU1OD",
  "BC": "VoiceConnectionStatus.module__chartLine___MWU1OD",
  "Pi": "VoiceConnectionStatus.module__chartPoint___MWU1OD",
  "Hh": "VoiceConnectionStatus.module__textGreen___MWU1OD",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___MWU1OD",
  "Bx": "VoiceConnectionStatus.module__iconSmall___MWU1OD",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___MWU1OD",
  "hz": "VoiceConnectionStatus.module__lockIcon___MWU1OD",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___MWU1OD",
  "uU": "VoiceConnectionStatus.module__nsOptions___MWU1OD",
};

module.exports = exports;
